import React, { useEffect, useState } from "react";
import { message, Modal, Form, Row, Col, InputNumber, Select } from "antd";
import { PlusSquareOutlined, MinusSquareOutlined } from "@ant-design/icons";
import AnalysisApi from "../../api/analysis";
import "./index.scss";

export default ({ controllType = 1, visible, onCancel }) => {
  const [form] = Form.useForm();
  const [expand, setExpand] = useState({});
  const [fieldsList, setFieldsList] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const options = [
    {
      label: "启动",
      value: 1,
    },
    {
      label: "停止",
      value: 0,
    },
  ];

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    AnalysisApi.getShartTimeControlAll(controllType).then((res) => {
      if (res.status !== "0") return;
      setFieldsList(res.data);
      const params = {};
      res.data
        .flatMap((item) => item.optionArr)
        .forEach((item) => {
          params[`${item.name}-${item.id}`] = item.val * 1;
        });
      form.setFieldsValue({ ...params });
    });
  };

  const changeExpand = (name) => {
    setExpand({
      ...expand,
      [name]: !expand[name],
    });
  };

  const submit = () => {
    form
      .validateFields()
      .then((values) => {
        const arr = Object.keys(values).map((key) => {
          const item = key.split("-");
          return {
            id: item[1],
            val: values[key],
          };
        });
        setConfirmLoading(true);
        AnalysisApi.editShartTimeControlVal(arr).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("修改成功");
          form.resetFields();
          onCancel();
        });
      })
      .catch(() => {
        message.error("请填写完整内容");
      });
  };

  const cancel = () => {
    onCancel && onCancel();
  };

  return (
    <Modal
      title="分时控制"
      open={visible}
      onOk={submit}
      onCancel={cancel}
      width={650}
      confirmLoading={confirmLoading}
    >
      <div style={{ height: 500, overflowY: "auto", padding: "0 10px" }}>
        <Form form={form}>
          {fieldsList.map((item) => {
            return (
              <Row key={item.name} className="time-sharing-control-item">
                <Col span={24} className="time-sharing-control-label">
                  {expand[item.name] ? (
                    <MinusSquareOutlined
                      onClick={() => changeExpand(item.name)}
                    />
                  ) : (
                    <PlusSquareOutlined
                      onClick={() => changeExpand(item.name)}
                    />
                  )}
                  <span>{item.name}</span>
                </Col>
                <Col
                  offset={2}
                  span={22}
                  style={{ display: expand[item.name] ? "block" : "none" }}
                >
                  <Row gutter={20}>
                    {item.optionArr.map((subItem) => {
                      return (
                        <Col span={12} key={subItem.id}>
                          <Form.Item
                            label={subItem.timeIcon}
                            name={`${item.name}-${subItem.id}`}
                            rules={[
                              {
                                required: true,
                                message: `请${
                                  subItem.type == 2 ? "选择" : "输入"
                                }`,
                              },
                            ]}
                          >
                            {subItem.type == 1 ? (
                              <InputNumber
                                style={{ width: "100%" }}
                                className="con-input-number"
                                placeholder="请输入"
                              />
                            ) : subItem.type == 2 ? (
                              <Select placeholder="请选择">
                                {options.map((opt) => (
                                  <Select.Option
                                    value={opt.value}
                                    key={opt.value}
                                  >
                                    {opt.label}
                                  </Select.Option>
                                ))}
                              </Select>
                            ) : subItem.type == 3 ? (
                              <InputNumber
                                style={{ width: "100%" }}
                                className="con-input-number"
                                placeholder="请输入"
                              />
                            ) : (
                              ""
                            )}
                          </Form.Item>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              </Row>
            );
          })}
        </Form>
      </div>
    </Modal>
  );
};
